export default __webpack_public_path__ + "static/media/img_top_2.c092a544.webp";